import React, { useState } from 'react';

const CustomModal = ({ product, onClose, onConfirm }) => {
  const initialSelections = {};
  if (product.options) {
    product.options.forEach(opt => {
      initialSelections[opt.title] = opt.choices[0];
    });
  }
  const [selections, setSelections] = useState(initialSelections);

  // 🎯 核心逻辑：根据 ID 精准读取您的两张备用图
  const getProductImages = (id) => {
    switch(id) {
      case 1: return ["/images/classic1.jpg", "/images/classic2.jpg"];
      case 2: return ["/images/corn1.jpg", "/images/corn2.jpg"];
      case 3: return ["/images/NYC1.jpg", "/images/NYC2.jpg"];
      case 4: return ["/images/BBQ1.jpg", "/images/BBQ2.jpg"];
      default: return ["", ""];
    }
  };

  const [img1, img2] = getProductImages(product.id);

  return (
    <div style={{
      position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh",
      backgroundColor: "rgba(0, 0, 0, 0.75)",
      display: "flex", justifyContent: "center", alignItems: "center",
      zIndex: 99999
    }}>
      
      <div style={{
        background: "white",
        width: "320px",          
        maxHeight: "85vh",
        padding: "20px",
        border: "5px solid #000",
        boxShadow: "8px 8px 0px #000",
        display: "flex",
        flexDirection: "column",
        position: "relative"
      }}>
        
        {/* 标题 */}
        <h2 style={{ borderBottom: '3px solid #000', paddingBottom: '10px', marginTop: 0, color: '#8b2e1f', fontSize: '20px', textAlign: 'center', fontWeight: '900' }}>
          {product.cn}
        </h2>
        
        {/* 📸 总统阁下指定的双图镶嵌位（在选项正上方） */}
        <div style={{ display: "flex", gap: "10px", marginBottom: "15px" }}>
          <div style={{ 
            flex: 1, 
            height: "120px", 
            border: "3px solid #000",
            backgroundImage: `url(${img1})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundColor: "#eee" /* 图片没加载出来时的底色 */
          }}></div>
          <div style={{ 
            flex: 1, 
            height: "120px", 
            border: "3px solid #000",
            backgroundImage: `url(${img2})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundColor: "#eee"
          }}></div>
        </div>

        {/* 选项区：酱料选择等 */}
        <div style={{ flex: 1, overflowY: 'auto', marginBottom: '10px', paddingRight: '5px' }}>
          {product.options ? product.options.map(opt => (
            <div key={opt.title} style={{ marginBottom: '15px' }}>
              <p style={{ fontWeight: '900', fontSize: '14px', margin: '0 0 8px 0' }}>{opt.title}</p>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                {opt.choices.map(c => {
                  const isActive = selections[opt.title] === c;
                  return (
                    <button
                      key={c}
                      onClick={() => setSelections({...selections, [opt.title]: c})}
                      style={{
                        padding: '6px 10px', border: '2px solid #000',
                        background: isActive ? '#ffd54f' : '#FFF',
                        fontWeight: 'bold', fontSize: '12px', cursor: 'pointer',
                        boxShadow: isActive ? 'none' : '2px 2px 0px #000',
                        transform: isActive ? 'translate(2px, 2px)' : 'none'
                      }}
                    >
                      {c}
                    </button>
                  );
                })}
              </div>
            </div>
          )) : <p style={{textAlign: 'center', fontWeight: 'bold'}}>标准配置，无需微调</p>}
        </div>

        {/* 底部按钮 */}
        <div style={{ display: 'flex', gap: '10px', marginTop: 'auto' }}>
          <button 
            onClick={() => onConfirm(selections)} 
            style={{ flex: 1, background: "#ffd54f", color: "#000", padding: '10px', fontWeight: '900', border: '3px solid #000', cursor: 'pointer', boxShadow: "2px 2px 0 #000" }}
          >
            确认
          </button>
          <button 
            onClick={onClose} 
            style={{ flex: 1, background: "#FFF", padding: '10px', fontWeight: '900', border: '3px solid #000', cursor: 'pointer', boxShadow: "2px 2px 0 #000" }}
          >
            取消
          </button>
        </div>

      </div>
    </div>
  );
};

export default CustomModal;